import React from "react";

import { useAppContext } from "@app/helpers/hooks";
import { collapseStops, expandStops } from "@app/tracking/itinerary-tracking";

import type {
  IntermediateStop as IntermediateStopType,
  ItineraryStopWithArrivalTime,
  ItineraryStopWithDepartureTime
} from "../types";

import { IntermediateStop } from "./intermediate-stop";
import { IntermediateStopsCollapse } from "./intermediate-stops-collapse";
import { getDayDifference } from "../../../helpers/date-helper";

interface Props {
  arrival_stop: ItineraryStopWithArrivalTime;
  departure_stop: ItineraryStopWithDepartureTime;
  direction: "outbound" | "return";
  stops: IntermediateStopType[];
}

function getDayDifferenceFromStops(
  departure_stop: ItineraryStopWithDepartureTime,
  arrival_stop: ItineraryStopWithArrivalTime
) {
  if (departure_stop.departure_time && arrival_stop.arrival_time) {
    return getDayDifference(
      departure_stop.departure_time,
      arrival_stop.arrival_time
    );
  }

  return 0;
}

export const IntermediateStops: React.FC<Props> = ({
  departure_stop,
  arrival_stop,
  direction,
  stops
}) => {
  const { tracker } = useAppContext();

  return (
    <IntermediateStopsCollapse
      arrival_time={arrival_stop.arrival_time}
      departure_time={departure_stop.departure_time}
      number_of_stops={stops.length}
      onExpand={() => tracker.track(expandStops(direction))}
      onCollapse={() => tracker.track(collapseStops(direction))}
    >
      {stops.map((stop, index) => (
        <IntermediateStop
          stop={stop}
          key={index}
          day_difference={
            // @ts-expect-error TS2345 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
            index > 0 ? getDayDifferenceFromStops(stops[index - 1], stop) : 0
          }
        />
      ))}
    </IntermediateStopsCollapse>
  );
};
